import React, { useEffect, useState } from 'react'
import TableFixedPage from '../../TableFixedPage/TableFixedPage';
import ActiveOrderPeykTable from '../../Tables/AllOrderPeyk/ActiveOrderPeykTable/ActiveOrderPeykTable';
import { errorToast } from '../../../Utils/Toast/Toast';
import { getAllOrderApi, getOrdersListApi } from '../../../Api/PanelAdminServices';
import { Modal } from "antd";
import UserInfo from '../../Modal/Information/UserInfo/UserInfo';
import OrderList from '../../Modal/Information/OrderList/OrderList';
import CancleOrder from '../../Modal/Information/CancleOrder/CancleOrder';
import OrderListAll from '../../Modal/Information/OrderListAll/OrderListAll';
import OrderListAllPeyk from '../../Modal/Information/OrderListAllPeyk/OrderListAllPeyk';

const ActiveOrderPeykContainer = () => {
    ///get active order /////
    const [activeOrder, setActivityOrder] = useState([]);
    const [orderDetail, setOrderDetail] = useState([]);
    useEffect(() => {
      getActiveOrder();
    }, []); 
  
    const getActiveOrder = async () => {
      getAllOrderApi((succ,res)=>{
        if(succ){
          if(res.status===0){
            errorToast("مشکلی پیش آمده است") 
          }else{
            const filteredData=res.orders.filter(el=>{
              if(el.status==="0" || el.status==="1" || el.status==="2" || el.status==="1.1" || el.status==="3"){
                return el.order_type==="magic"
              }else return false
            })
            setActivityOrder(filteredData);
          }
        }else{
          errorToast("خطایی در سرور رخ داده است")
        }
      })
    };
    ///////modal order list///////////
    const [isOrderVisible, setIsOrderVisible] = useState(false);
    const [isSureVisible, setIsSureVisible] = useState(false);
    const [rawInfo, setRawInfo] = useState();
    const [addressUser, setAddressUser] = useState();
    const showOrder = async (info) => {
      console.log(info)
      getOrdersListApi(info.orderNumber, 0,(succ,res)=>{
        if(succ){
          if(res.status===0){
            errorToast("مشکلی پیش آمده است")
          }else{
            console.log(res.orders)
            setOrderDetail(res.orders)
          }
        }else{
          errorToast("خطایی در سرور رخ داده است")
        }
      });
      setIsOrderVisible(true);
    };
    const showSure = (info) => {
      setRawInfo(info);
      setIsSureVisible(true);
    };
  
    const handleSure = () => {
      setIsSureVisible(false);
    };
    const handleOkOrder = async () => {
      setIsOrderVisible(false);
    };
    const data =
      activeOrder &&
      activeOrder.map((item, index) => {
        return {
          key: index,
          person: item.first_name + " " + item.last_name,
          city: item.city,
          orderNumber: item.id,
          date: item.date,
          address:item.address,
          phone:item.customer_phone
        };
      });
    //////modal user info////////////
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = (data) => {
      setAddressUser(data)
      setIsModalVisible(true);
    };
  
    const handleOk = () => {
      setIsModalVisible(false);
    };
    return (
      <div>
        <Modal
          width={350}
          title="اطلاعات شخص"
          open={isModalVisible}
          onOk={handleOk}
          footer={null}
        >
          <UserInfo showAddress={true} Info={addressUser} address={addressUser&&addressUser.address} handleOk={handleOk} />
        </Modal>
        <Modal
          width={350}
          title={"رد کردن سفارش"}
          open={isSureVisible}
          onOk={handleOk}
          footer={null}
        >
          <CancleOrder
            item={orderDetail}
            rawInfo={rawInfo}
            handleSure={handleSure}
          />
        </Modal>
        <Modal
          width={350}
          title="لیست سفارش"
          open={isOrderVisible}
          onOk={handleOkOrder}
          footer={null}
        >
          <OrderListAllPeyk item={orderDetail} handleOk={handleOkOrder} />
        </Modal>
        <TableFixedPage title={"سفارشات فعال پیک"} />
        <ActiveOrderPeykTable
          showSure={showSure}
          showOrder={showOrder}
          showModal={showModal}
          data={data}
        /> 
      </div>
    );
  };

export default ActiveOrderPeykContainer